import React from 'react'
import { AuthorizedCommonDiscount } from './AuthorizedCommonDiscount';
import { DeleteDiscountCommon } from './DeleteDiscountCommon';
import { FormCommonDiscounts } from './FormCommonDiscounts';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';




export const ModalCommonDiscount = (props) => {

    const {
        modal, toggleModal, modalTitle, method, loading,
        id_gender, name, code, valid_from, valid_to, days_of_week,
        percentage, auto_redeem, accumulative, percentage_global, day_from,
        day_to, list_exams_includes, list_exams_excludes, list_profiles_includes,

        treeViewRef,

        listBranchesTree, listSections, listExamsFiltered, listProfiles,

        handleInputChange, handleChangeSections, handleSelectExamsIncludes,
        handleChangePercentage, handleRemoveTest, handleSelectProfilesIncludes,
        handleCheckDaysOfWeek, saveCommonDiscount, saveDelete, saveAuthorized,

        validationsCommonDiscount,

    } = props;


    // * CONFIGURATION DESING DIALOG
    const dialogTheme = method === "delete"
        ?
        ` seller-dialog seller-dialog seller-danger seller-small-v`
        :
        (method === "auth" || method === "unAuth")
            ?
            ` Global-dialog Global-blue Global-small-v`
            :
            "Global-dialog Global-blue Global-large ";





    const icon = method === "delete"
        ? <i className="fa fa-trash"></i>
        : method === "auth" ? <i className="fa fa-lock"></i> : method === "unAuth"
            ? <i className="fa fa-unlock-alt"></i>

            : <i className="fa fa-tags"></i>

    return (
        <Dialog
            visible={modal}
            onHide={toggleModal}
            modal
            closable={false}
            dismissableMask={false}
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            {icon}
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}

                            </div>
                        </div>
                    </div>
                </div>
            }
            className={` ${dialogTheme}`}
            maskClassName="custom-total-mask"
            blockScroll={true}
            footer={
                <>
                    {
                        (method === "create" || method === "update") && <>
                            {
                                <Button onClick={() => saveCommonDiscount(method)} color='secondary' type='button' className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                                    {method === "create" ? "Crear campaña" : (method === "update" ? "Editar campaña" : "")}
                                </Button>
                            }
                            <Button color='danger' type='button' onClick={toggleModal}>
                                {
                                    method === "view" ? true : false ? "Cerrar visualización" : "Cancelar"
                                }
                            </Button>
                        </>
                    }

                    {
                        (method === "auth" || method === "unAuth") && <>
                            <Button
                                onClick={(e) => saveAuthorized(e, method === "auth" ? "autorizar" : "desautorizar")}
                                color="secondary"
                                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            >
                                Sí, {method === "auth" ? "autorizar" : "desautorizar"}
                            </Button>

                            <Button className="btn-air-light" color='danger' type="button" onClick={toggleModal}>Cancelar</Button>
                        </>
                    }
                    {
                        (method === "delete") && <>
                            <Button
                                onClick={saveDelete}
                                color="secondary"
                                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            >
                                Sí, eliminar
                            </Button>
                            <Button className="btn-air-light" color="danger" type="button" onClick={toggleModal}>Cancelar</Button>
                        </>
                    }
                </>
            }
        >
            {
                method === "delete" ?
                    <DeleteDiscountCommon
                        {
                        ...{ toggleModal, loading, saveDelete, name, code, }
                        }
                    />
                    :
                    ((method === "auth" || method === "unAuth") ?
                        <AuthorizedCommonDiscount
                            typeAuthorization={method === "auth" ? "autorizar" : "desautorizar"}
                            {
                            ...{ toggleModal, loading, saveAuthorized, name, code }
                            }
                        />
                        :
                        <FormCommonDiscounts
                            readOnly={method === "view" ? true : false}
                            button={method === "create" ? "Crear campaña" : (method === "update" ? "Editar campaña" : "")}
                            {...{
                                method, toggleModal, loading,
                                id_gender, name, code, valid_from, valid_to, days_of_week,
                                percentage, auto_redeem, accumulative, percentage_global, day_from,
                                day_to, list_exams_includes, list_exams_excludes, list_profiles_includes,

                                treeViewRef,

                                listBranchesTree, listSections, listExamsFiltered, listProfiles,

                                handleInputChange, handleChangeSections, handleSelectExamsIncludes,
                                handleChangePercentage, handleRemoveTest, handleSelectProfilesIncludes,
                                handleCheckDaysOfWeek, saveCommonDiscount,

                                validationsCommonDiscount
                            }}
                        />
                    )
            }
        </Dialog >

    )
}
